import { GoalType } from '@griply/types';
import { useTimeframeTime } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoalInsightsCard } from 'shared/components/connected/goal-insights-card';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useListColumns } from 'shared/hooks/use-list-columns';

import { useInsightsGoals } from '../../hooks/use-insights-goals';
import { EmptyMessage } from '../empty-message';
import * as Styled from './goals-insights.style';

const goalTypes = [GoalType.Goal];

export const GoalsInsights: React.FC = () => {
  const widthRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const goals = useInsightsGoals(goalTypes);
  const { startDate, endDate } = useTimeframeTime({
    weekEndsWithStartOfDay: true,
  });

  const listColumns = useListColumns(widthRef);

  return (
    <PageSectionBase
      title={t('pages.insights.sections.goals.title')}
      fullSize={!goals.length}
      noPadding
    >
      {goals.length ? (
        <>
          <Styled.WidthRef ref={widthRef} />
          <Styled.List $columns={listColumns}>
            {goals.map((goal) => (
              <Styled.ListItem $columns={listColumns} key={goal.id}>
                <GoalInsightsCard
                  goal={goal}
                  startDate={startDate}
                  endDate={endDate}
                  isLink
                  canUpdateProgress
                />
              </Styled.ListItem>
            ))}
          </Styled.List>
        </>
      ) : (
        <EmptyMessage isGoal />
      )}
    </PageSectionBase>
  );
};
